export default {
  GET_RESIDENCESE_QUERY_SERVICE: Symbol.for('GET_RESIDENCESE_QUERY_SERVICE'),
  RESIDENCE_REPOSITORY: Symbol.for('RESIDENCE_REPOSITORY'),
  ONBOARDING_CATALOG_RESIDENCE_STATE_MANAGER:
    Symbol.for('ONBOARDING_CATALOG_RESIDENCE_STATE_MANAGER'),
};
